import { OrderType } from "../common/companyOrderTypes";

export interface CancellationSummary {
  beneficiaryName: string;
  purpose: string;
  periodStart: string | null;
  periodEnd: string | null;
  mwh: number | null;
}

/**
 * Normalize order_details of cancel-type orders into per-statement summaries
 * for the confirmation modal. Returns [] for other order types or unexpected
 * shapes — callers fall back to the plain confirmation text.
 */
export function extractCancellationSummaries(
  orderType: OrderType,
  details: unknown
): CancellationSummary[] {
  if (!details || typeof details !== "object") return [];
  const record = details as Record<string, any>;

  if (orderType === OrderType.CANCEL) {
    if (!Array.isArray(record.statements)) return [];
    return record.statements
      .filter((stmt: any) => stmt && typeof stmt === "object")
      .map((stmt: any) => ({
        beneficiaryName: stmt.beneficiary_name ?? "",
        purpose: stmt.cancellation_purpose ?? "",
        periodStart: stmt.period_start ?? null,
        periodEnd: stmt.period_end ?? null,
        mwh: stmt.mwh_cancelled ?? null,
      }));
  }

  if (orderType === OrderType.BUY_AND_CANCEL) {
    const purpose = record.cancellation_settings?.cancellation_purpose;
    if (!record.beneficiary_name || !purpose) return [];
    return [
      {
        beneficiaryName: record.beneficiary_name,
        purpose,
        periodStart: null,
        periodEnd: null,
        mwh: record.volume ?? null,
      },
    ];
  }

  return [];
}
